import { documentInternationalization } from "@sanity/document-internationalization";
import { visionTool } from "@sanity/vision";
import { defineConfig } from "sanity";
import { media } from "sanity-plugin-media";
import { StructureResolver, structureTool } from "sanity/structure";
import schemaTypes from "./schemas/schema";
import { SANITY_DATASET as dataset } from "./lambda/shared/sanity-config";

const deskStructure: StructureResolver = (S) => {
  return S.list()
    .title("Classification")
    .items([
      S.listItem()
        .title("Educational Content")
        .child(
          S.list()
            .title("Educational Content")
            .items([
              S.listItem()
                .title("Articles")
                .child(
                  S.list()
                    .title("Articles")
                    .items([
                      S.listItem()
                        .title("Articles English")
                        .child(
                          S.documentTypeList("educationalContent")
                            .title("Articles English")
                            .filter(
                              '_type == "educationalContent" && language == "en" && type == "article"'
                            )
                        ),
                      S.listItem()
                        .title("Articles Spanish")
                        .child(
                          S.documentTypeList("educationalContent")
                            .title("Articles Spanish")
                            .filter(
                              '_type == "educationalContent" && language == "es" && type == "article"'
                            )
                        )
                    ])
                ),
              S.listItem()
                .title("Videos")
                .child(
                  S.list()
                    .title("Videos")
                    .items([
                      S.listItem()
                        .title("Videos English")
                        .child(
                          S.documentTypeList("educationalContent")
                            .title("Videos English")
                            .filter(
                              '_type == "educationalContent" && language == "en" && type == "video"'
                            )
                        ),
                      S.listItem()
                        .title("Videos Spanish")
                        .child(
                          S.documentTypeList("educationalContent")
                            .title("Videos Spanish")
                            .filter(
                              '_type == "educationalContent" && language == "es" && type == "video"'
                            )
                        )
                    ])
                ),
              S.listItem()
                .title("Others")
                .child(
                  S.documentTypeList("educationalContent")
                    .title("Others")
                    .filter(
                      '_type == "educationalContent" && type != "article" && type != "video"'
                    )
                ),
              S.divider(),
              S.listItem()
                .title("Categories")
                .child(
                  S.documentTypeList("categoryContent").title(
                    "Category Content"
                  )
                ),
              S.divider(),
              S.listItem()
                .title("Structured Journeys")
                .child(
                  S.list()
                    .title("Journal Content")
                    .items([
                      S.listItem()
                        .title("Journey")
                        .child(
                          S.list()
                            .title("Journey")
                            .items([
                              S.listItem()
                                .title("Journey English")
                                .child(
                                  S.documentTypeList("journeyContent")
                                    .title("Journey English")
                                    .filter(
                                      '_type == "journeyContent" && language == "en"'
                                    )
                                ),
                              S.listItem()
                                .title("Journey Spanish")
                                .child(
                                  S.documentTypeList("journeyContent")
                                    .title("Journey Spanish")
                                    .filter(
                                      '_type == "journeyContent" && language == "es"'
                                    )
                                )
                            ])
                        ),
                      S.listItem()
                        .title("Class")
                        .child(
                          S.list()
                            .title("Class")
                            .items([
                              S.listItem()
                                .title("Class English")
                                .child(
                                  S.documentTypeList("classContent")
                                    .title("Class English")
                                    .filter(
                                      '_type == "classContent" && language == "en"'
                                    )
                                ),
                              S.listItem()
                                .title("Class Spanish")
                                .child(
                                  S.documentTypeList("classContent")
                                    .title("Class Spanish")
                                    .filter(
                                      '_type == "classContent" && language == "es"'
                                    )
                                )
                            ])
                        ),
                      S.listItem()
                        .title("Lesson")
                        .child(
                          S.list()
                            .title("Lesson")
                            .items([
                              S.listItem()
                                .title("Lesson English")
                                .child(
                                  S.documentTypeList("lessonContent")
                                    .title("Lesson English")
                                    .filter(
                                      '_type == "lessonContent" && language == "en"'
                                    )
                                ),
                              S.listItem()
                                .title("Lesson Spanish")
                                .child(
                                  S.documentTypeList("lessonContent")
                                    .title("Lesson Spanish")
                                    .filter(
                                      '_type == "lessonContent" && language == "es"'
                                    )
                                )
                            ])
                        )
                    ])
                ),

              S.divider(),
              S.listItem()
                .title("Settings")
                .child(
                  S.editor()
                    .schemaType("educationSettings")
                    .documentId("educationSettings")
                ),
              S.divider(),
              S.listItem()
                .title("[SYNCED DATABASE] Sanctuary Health Videos")
                .child(
                  S.documentTypeList("sanctuaryHealthVideo").title(
                    "Sanctuary Health Videos"
                  )
                )
            ])
        ),
      // program content
      S.divider(),
      S.listItem()
        .title("App Config")
        .child(
          S.list()
            .title("App Config")
            .items([
              S.listItem()
                .title("Program Content")
                .child(
                  S.documentTypeList("programContent").title("Program Content")
                ),
              S.listItem()
                .title("Miscellaneous Content")
                .child(
                  S.document({
                    id: "appContent",
                    title: "App Content",
                    options: {
                      type: "appContentType"
                    }
                  })
                ),
              S.listItem()
                .title("Establish Care Step Settings")
                .child(
                  S.document({
                    id: "establishcarestepsettings",
                    title: "Establish Care Step Settings",
                    options: {
                      type: "establishCareStepSettings"
                    }
                  })
                ),
              S.listItem()
                .title("Support Availability")
                .child(
                  S.document({
                    id: "supportAvailability",
                    title: "Support Availability",
                    options: {
                      type: "supportAvailability"
                    }
                  })
                )
            ])
        ),
      S.listItem()
        .title("Feature Flags")
        .child(
          S.document({
            id: "featureflags",
            title: "Feature Flags",
            options: {
              type: "featureFlag"
            }
          })
        ),
      S.divider(),
      S.listItem()
        .title("Translations")
        .child(
          S.documentTypeList("translation.metadata").title("Translations")
        ),
      S.divider(),
      S.listItem()
        .title("Other Data")
        .child(
          S.list()
            .title("Other Data")
            .items([
              // all others
              ...S.documentTypeListItems().filter(
                (listItem) =>
                  ![
                    "educationalContent",
                    "programContent",
                    "categoryContent",
                    "journeyContent",
                    "classContent",
                    "lessonContent",
                    "featureFlag",
                    "establishCareStepSettings",
                    "translation.metadata",
                    "appContentType"
                  ].includes(listItem.getId() ?? "")
              )
            ])
        )
    ]);
};

const sanityConfig = defineConfig({
  // basePath removed - Studio is now hosted at root
  // Load project id and dataset name as environment variables.
  projectId: "g38rxyoc",
  dataset: dataset,
  title: `9am CMS (${dataset})`,
  plugins: [
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- structureTool is typed as `any` in sanity v5
    structureTool({
      structure: deskStructure
    }),
    media(),
    visionTool(),
    documentInternationalization({
      supportedLanguages: [
        { id: "en", title: "English" },
        { id: "es", title: "Spanish" }
      ],
      schemaTypes: [
        "programContent",
        "educationalContent",
        "categoryContent",
        "journeyContent",
        "classContent",
        "lessonContent",
        "programFileAttachment",
        "programModuleItem",
        "appointmentType",
        "careTeam"
      ]
    })
  ],
  schema: {
    types: schemaTypes
  }
});

export default sanityConfig;
